import { render } from "./SepaDirectDebitCard.vue?vue&type=template&id=fa6333ea"
import script from "./SepaDirectDebitCard.vue?vue&type=script&lang=js"
export * from "./SepaDirectDebitCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__